
const {get, del}= require('../request')
const {parse} = require('../html')
const layout = require('./app.html')
const loadingLayout = require('./loading.html')

const AddAnalysis = require('../analysis/add_analysis')
const AddVisualiser = require('../analysis/add_visualiser')

const WordCloud = require('../visualiser/cloud')

const App = class {
    constructor(api, document) {
        this.api = api
        this.document = document
        this.tokenizers = []
        this.analyses = []
        this.analysesId = 0
    }
    dom() {
        const {document} = this
        const content = parse(layout, {document}).querySelector('#app')
        const navButton = content.querySelector('button#toggle-nav')
        const asideButton = content.querySelector('button#toggle-aside')
        const nav = content.querySelector('nav.app-nav')
        const navContent = nav.querySelector('div#analyses')
        const main = content.querySelector('main.app-main#main')
        const aside = content.querySelector('aside.app-aside')

        const toggleNav = () => nav.classList.toggle('hidden')
        navButton.addEventListener('click', toggleNav)

        const toggleAside = () => aside.classList.toggle('hidden')
        asideButton.addEventListener('click', toggleAside)

        const getMain = () => main.firstChild
        const setMain = (content, hideNav=true) => {
            main.innerHTML = ''
            if(content) main.appendChild(content)
            if(content && hideNav) nav.classList.add('hidden')
        }

        // 문서 삭제
        const deleteDocument = () => {
            const password = content.querySelector('#password').value
            if(confirm(`'${this.document.title}' 문서를 삭제하시겠습니까?`)) {
                del(host, port, `/document/${this.document.name}`, {password}).then((result) => {
                    if(result.error) return alert(result.error)
                    alert('문서를 삭제했습니다.')
                    location.reload()
                })
            }
        }

        const addAnalysis = () => {
            // 분석 추가 페이지를 생성
            const page = new AddAnalysis(this.api, this.document, this.tokenizers, content.querySelector('#password').value)
            // 분석 추가 페이지를 표시
            setMain(page.dom())
            // 분석 추가 페이지의 결정 버튼에 대한 동작
            page.onadd = (analysis) => {
                // 일련번호를 이용하여 임시 이름 생성
                const id = ++this.analysesId
                analysis.name = `분석 ${id}`
                // 로드 중 화면 표시
                const config = {document, tokenizer: analysis.config.tokenizer}
                setMain(parse(loadingLayout, {config}).querySelector('#content'))
                // 분석을 실행하고
                analysis.run().then(() => {
                    // 요약 페이지를 생성
                    const content = analysis.dom()
                    // 메인 화면에 표시하는 함수 정의
                    const show = () => {
                        // 메인 화면에 요약 페이지를 표시
                        setMain(content)
                        // 단어 구름을 갱신
                        setCloud(analysis)
                    }
                    // 탐색 메뉴에 표시할 항목을 생성
                    const item = analysis.nav()
                    // 생성한 항목을 탐색 메뉴에 추가
                    navContent.appendChild(item)
                    // 항목에 있는 제거 버튼에 대한 동작
                    item.querySelector('button#remove').addEventListener('click', () => {
                        // 분석 목록에서 분석 제거
                        this.analyses.splice(this.analyses.indexOf(analysis), 1)
                        // 탐색 메뉴에서 항목 제거
                        navContent.removeChild(item)
                        // 메인 화면에 표시중일 경우 메인 화면에서도 제거
                        if(getMain() == content) setMain(null)
                        // 메인 화면에 해당 분석의 시각화가 표시중인 경우 메인 화면에서 제거
                        if(analysis.visualisers.map(v => v.domContent).includes(getMain())) setMain(null)
                        // 메인 화면이 제거됐을 경우 단어 구름도 제거
                        if(getMain() == null) setCloud(null)
                    })
                    // 메뉴 항목에 있는 (시각화) 추가 버튼에 대한 동작
                    item.querySelector('button#add').addEventListener('click', () => {
                        addVisualiser(analysis, item.querySelector('#visualisers'))
                    })
                    // 내용에 있는 시각화 추가 버튼에 대한 동작
                    content.querySelector('button#add-visualiser').addEventListener('click', () => {
                        addVisualiser(analysis, item.querySelector('#visualisers'))
                    })
                    // 요약 페이지를 메인 화면에 표시
                    show()
                    // 탐색 메뉴에서 클릭하면 해당 요약 페이지를 다시 표시
                    item.querySelector('.title-bar > #name').addEventListener('click', () => show())
                    // 분석 목록에 추가
                    this.analyses.push(analysis)
                })
            }
        }

        const addVisualiser = (analysis, navItemContent) => {
            // 시각화 추가 페이지를 생성
            const page = new AddVisualiser(analysis)
            setMain(page.dom())
            // 분석 추가 페이지의 결정 버튼에 대한 동작
            page.onadd = (visualiser) => {
                // 탐색 메뉴에 표시할 항목을 생성
                const item = visualiser.nav()
                // 생성한 항목을 탐색 메뉴에 추가
                navItemContent.appendChild(item)
                // 항목에 있는 제거 버튼에 대한 동작
                item.querySelector('button#remove').addEventListener('click', () => {
                    // 분석의 시각화 목록에서 해당 시각화를 제거
                    analysis.visualisers.splice(analysis.visualisers.indexOf(visualiser), 1)
                    // 탐색 메뉴에서 항목 제거
                    navItemContent.removeChild(item)
                    // 메인 화면에 표시중일 경우 메인 화면에서도 제거
                    if(getMain() == content) setMain(null)
                    // 메인 화면이 제거됐을 경우 단어 구름도 제거
                    if(getMain() == null) setCloud(null)
                })
                // 시각화 페이지를 생성해서 표시
                const content = visualiser.dom()
                // 메인 화면에 표시하는 함수 정의
                const show = () => {
                    // 메인 화면에 요약 페이지를 표시
                    setMain(content)
                    // 단어 구름을 갱신
                    setCloud(analysis, (data) => visualiser.data(data))
                }
                // 메인 화면에 시각화 표시
                show()
                // 탐색 메뉴에서 클릭하면 해당 시각화를 다시 표시
                item.querySelector('.title-bar > #name').addEventListener('click', () => show())
                // 분석의 시각화 목록에 추가
                analysis.visualisers.push(visualiser)
                visualiser.domContent = content
            }
        }

        // 분석 추가 버튼에 대한 동작
        nav.querySelector('button#add-analysis').addEventListener('click', () => addAnalysis())
        // 문서 삭제 버튼에 대한 동작
        nav.querySelector('button#delete-document').addEventListener('click', () => deleteDocument())

        const setCloud = (analysis, ondata=(() => {})) => {
            const div = aside.querySelector('div#word-cloud')
            div.innerHTML = ''
            if(analysis == null) return
            const cloud = new WordCloud(analysis)
            cloud.ondata = ondata
            const content = cloud.dom()
            div.appendChild(content)
        }

        const {host, port} = this.api
        // 형태소 분석기 목록 가져오기
        get(host, port, '/tokenizer').then(({tokenizers}) => {
            this.tokenizers = tokenizers
        })

        return content
    }
}

module.exports = App
